(function() {
    'use strict';

    angular.module('swif.framework')
    .factory('swifAvailableService', swifAvailableService);

    /**
    * @ngdoc service
    * @name swif.framework.swifAvailableService
    * @requires swif.framework.userService
    * @requires swif.framework.swifModule
    * @requires swif.framework.settingsService
    * @requires swif.framework.swifFrameworkCartService
    **/
    function swifAvailableService($parse, userService, swifModule, settingsService, swifFrameworkCartService) {
        'ngInject';
        var settings = settingsService;
        var swifCart = swifFrameworkCartService;
        var service = {};
        service.isAvailable = function (model, context) {
            if (!model) {
                return false;
            }
            var res = true;
            if (context === undefined) {
                context = {};
            }
            var user = userService.getAuthenticatedUserData();
            var access_rights = userService.getAccessRights();
            _.defaults(context, {
                u: user,
                access_rights: access_rights,
                m: swifModule,
                settings: settings,
                cart: swifCart,
                _: _
            });
            if (model.available !== undefined) {
                res = $parse(model.available)(context);
            }
            return res;
        };
        return service;
    }

})();
